import { render, staticRenderFns } from "./SavedCards.vue?vue&type=template&id=b58ebe26"
import script from "./SavedCards.vue?vue&type=script&lang=js"
export * from "./SavedCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports